const memory = new Map();

export function rememberServiceMode(storeId, mode) {
  if (!storeId) return;
  memory.set(String(storeId), mode === "assigned" ? "assigned" : "shared");
}

export function readServiceMode(storeId, store) {
  const id = String(storeId || store?.id || "");
  const explicit = store?.serviceMode;
  if (explicit === "assigned" || explicit === "shared") {
    if (id) memory.set(id, explicit);
    return explicit;
  }
  return memory.get(id) || "shared";
}
